/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import {
  adminActions,
  adminCreateLead,
  adminUpdateLead,
  ConfirmationTypes,
  existingUserDetails,
  HelpTypes,
  ICreateLeadParams,
  leadSelector,
  resetStatus,
  successSelector,
} from '@pharmaplan/common';

import { Box, Typography } from '@mui/material';
import { useAppSelector } from '../../useAppSelector';
import { useAppDispatch } from '../../useAppDispatch';
import { setDialog } from '../../../reducers/dialogReducer';
import OutcomeModal from '../../../components/Modals/OutcomeModal';
import { OutcomeModalTypes, UserLabels } from '../../../helpers/Constants';
import strings from '../../../localization';
import ConfirmationModal from '../../../components/Modals/ConfirmationModal';
import { showError } from '../../../components/Admin/Profile/Pharmacist/PharmacistViewProfile/helper';

interface IUseExistingLeads {
  leadId: string;
  isEdit?: boolean;
  enabled?: boolean;
  payload: ICreateLeadParams;
}

const useExistingLeads = ({
  payload,
  isEdit,
  leadId,
  enabled = true,
}: IUseExistingLeads) => {
  const dispatch = useAppDispatch();
  const lead = useAppSelector(leadSelector);
  const savedEmail = lead?.email;

  const success = useAppSelector((state) =>
    successSelector([adminActions.getExistingUserDetails], state));
  const existingUser = useAppSelector(existingUserDetails);
  const { user, isLeadMapped } = existingUser ?? {};
  const { userType = HelpTypes.pharmacy } = user ?? {};

  const createEditLead = () => {
    if (isEdit && leadId) {
      dispatch(
        adminUpdateLead({
          ...payload,
          leadId,
          userType: userType ?? HelpTypes.pharmacy,
        }),
      );
      return;
    }

    dispatch(adminCreateLead(payload));
  };

  const leadsProc = () => {
    // DO NOT CALL API TO CHECK IF EMAIL IS ALREADY SAME
    if (isEdit && savedEmail === payload?.email) {
      createEditLead();
      return;
    }

    if (isLeadMapped) {
      showError(dispatch, strings.userAlreadyRegisteredLead);
      return;
    }

    if (user && `${userType}` !== payload.userType) {
      dispatch(
        setDialog({
          Component: (
            <OutcomeModal
              message={strings.formatString(
                strings.thisUserAlreadyExistsAs,
                UserLabels()[userType],
              )}
              type={OutcomeModalTypes.error}
            />
          ),
          heading: {
            title: '',
          },
          showCloseButton: true,
        }),
      );
      return;
    } if (user?.userType) {
      dispatch(
        setDialog({
          Component: (
            <ConfirmationModal
              customMessage={(
                <Box>
                  <Typography sx={{ fontSize: 15, textAlign: 'center' }}>
                    {strings.formatString(
                      strings.thisUserAlreadyExistsAs,
                      UserLabels()[userType],
                    )}
                  </Typography>
                  <Typography sx={{ fontSize: 15, textAlign: 'center' }}>
                    {strings.areYouSureContinue}
                  </Typography>
                </Box>
                )}
              type={ConfirmationTypes.promoExistUser}
              confirmAction={createEditLead}
            />
          ),
          heading: {
            title: '',
          },
          showCloseButton: false,
        }),
      );
      return;
    }

    createEditLead();
  };

  useEffect(() => {
    if (success) {
      if (enabled) {
        leadsProc();
      }
      dispatch(resetStatus([adminActions.getExistingUserDetails]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, existingUser, success, leadsProc]);
};

export default useExistingLeads;
